// export const DEBUG_FAKE_DATE: Date | null = new Date(
//   "2025-08-04T07:30:25+00:00"
//   // "2025-10-04T07:30:25+00:00"
// );
export const DEBUG_FAKE_DATE: Date | null = null;

export function dateNow(): Date {
  if (DEBUG_FAKE_DATE) {
    if (process.env.NODE_ENV !== "development") {
      throw new Error("fake date only allowed in development for now");
    }

    return DEBUG_FAKE_DATE;
  }

  return new Date();
}

export function dateAtStartOfDay(date: Date): Date {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

export function dateAtEndOfDay(date: Date): Date {
  return new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    23,
    59,
    59
  );
}

export function daysLeftUntil(date: Date) {
  const now = dateAtStartOfDay(dateNow());
  const diff = dateAtEndOfDay(date).getTime() - now.getTime();
  return Math.ceil(diff / (1000 * 60 * 60 * 24));
}

export function formattedDate(
  date: Date | null | undefined,
  locale: string
): string {
  if (!date) {
    return "";
  }

  return date.toLocaleDateString(locale, {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}

export function hoursToMillis(hours: number) {
  return hours * 1000 * 60 * 60;
}

export function daysToMillis(days: number) {
  return days * hoursToMillis(24);
}
